import { combineReducers } from 'redux';

const departments = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_DEPARTMENTS_FULFILLED':
      return action.payload.data.result;
    case 'FETCH_ALL_DEPARTMENTS_REJECTED':
      return [];
    default:
      return state;
  }
};

const departmentsTotal = (state = 0, action) => {
  switch (action.type) {
    case 'FETCH_ALL_DEPARTMENTS_FULFILLED':
      return action.payload.data.totalCount;
    case 'FETCH_ALL_DEPARTMENTS_REJECTED':
      return 0;
    default:
      return state;
  }
};

const roles = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_ROLES_FULFILLED':
      return action.payload.data;
    case 'FETCH_ALL_ROLES_REJECTED':
      return [];
    default:
      return state;
  }
};

const categories = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_CATEGORIES_FULFILLED':
      return action.payload.data;
    case 'FETCH_ALL_CATEGORIES_REJECTED':
      return [];
    default:
      return state;
  }
};
const questionTypes = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_QUESTION_TYPES_FULFILLED':
      return action.payload.data;
    case 'FETCH_ALL_QUESTION_TYPES_REJECTED':
      return [];
    default:
      return state;
  }
};
const configs = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_CONFIGS_FULFILLED':
      return action.payload.data;
    case 'FETCH_ALL_CONFIGS_REJECTED':
      return [];
    default:
      return state;
  }
};

const status = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_USER_STATUS_FULFILLED':
      return action.payload.data;
    case 'FETCH_USER_STATUS_REJECTED':
      return [];
    default:
      return state;
  }
};

const requestStatus = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_REQUEST_STATUS_FULFILLED':
      return action.payload.data;
    default:
      return state;
  }
};

const isLoadedRequestStatus = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST_STATUS_FULFILLED':
      return true;
    case 'FETCH_REQUEST_STATUS_REJECTED':
    case 'FETCH_REQUEST_STATUS_PENDING':
      return false;
    default:
      return state;
  }
};

const vendorStatus = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_VENDOR_STATUS_FULFILLED':
      return action.payload.data;
    default:
      return state;
  }
};

const questionStatus = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_QUESTION_STATUS_FULFILLED':
      return action.payload.data;
    default:
      return state;
  }
};

const questionStatusLoaded = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_QUESTION_STATUS_FULFILLED':
      return true;
    case 'FETCH_QUESTION_STATUS_PENDING':
      return false;
    default:
      return state;
  }
};

const prescreenFiles = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_UPLOADED_FILES_FULFILLED':
      return action.payload.data.PRESCREEN;
    case 'FETCH_UPLOADED_FILES_REJECTED':
      return [];
    default:
      return state;
  }
};

const questionnaireFiles = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_UPLOADED_FILES_FULFILLED':
      return action.payload.data.QUESTIONNAIRE;
    case 'FETCH_UPLOADED_FILES_REJECTED':
      return [];
    default:
      return state;
  }
};

const reviewFiles = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_UPLOADED_FILES_FULFILLED':
      return action.payload.data.REVIEW;
    case 'FETCH_UPLOADED_FILES_REJECTED':
      return [];
    default:
      return state;
  }
};

const auditLog = (state = { totalCount: 0, logs: [] }, action) => {
  switch (action.type) {
    case 'FETCH_AUDIT_LOG_FULFILLED':
      return action.payload.data;
    case 'FETCH_AUDIT_LOG_REJECTED':
      return { totalCount: 0, logs: [] };
    default:
      return state;
  }
};

const isFetchingAuditLog = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_AUDIT_LOG_FULFILLED':
    case 'FETCH_AUDIT_LOG_REJECTED':
      return false;
    case 'FETCH_AUDIT_LOG_PENDING':
      return true;
    default:
      return state;
  }
};

const auditLogExports = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_AUDIT_LOG_EXPORTS_FULFILLED':
      return action.payload.data.logs;
    case 'FETCH_AUDIT_LOG_EXPORTS_REJECTED':
      return [];
    default:
      return state;
  }
};

const isFetchingAuditLogExports = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_AUDIT_LOG_EXPORTS_FULFILLED':
      return false;
    case 'FETCH_AUDIT_LOG_EXPORTS_PENDING':
      return true;
    default:
      return state;
  }
};

const isFetchingDepartments = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_ALL_DEPARTMENTS_PENDING':
      return true;
    case 'FETCH_ALL_DEPARTMENTS_REJECTED':
    case 'FETCH_ALL_DEPARTMENTS_FULFILLED':
      return false;
    default:
      return state;
  }
};

const isLoadedDepartments = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_ALL_DEPARTMENTS_FULFILLED':
      return true;
    case 'FETCH_ALL_DEPARTMENTS_REJECTED':
    case 'FETCH_ALL_DEPARTMENTS_PENDING':
      return false;
    default:
      return state;
  }
};

const isFetchingRoles = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_ALL_ROLES_PENDING':
      return true;

    case 'FETCH_ALL_ROLES_REJECTED':
    case 'FETCH_ALL_ROLES_FULFILLED':
      return false;
    default:
      return state;
  }
};
const isFetchingCategories = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_ALL_CATEGORIES_PENDING':
      return true;
    case 'FETCH_ALL_CATEGORIES_REJECTED':
    case 'FETCH_ALL_CATEGORIES_FULFILLED':
      return false;
    default:
      return state;
  }
};

const isFetchingTypes = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_ALL_QUESTION_TYPES_PENDING':
      return true;
    case 'FETCH_ALL_QUESTION_TYPES_REJECTED':
    case 'FETCH_ALL_QUESTION_TYPES_FULFILLED':
      return false;
    default:
      return state;
  }
};

const isLoadedTypes = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_ALL_QUESTION_TYPES_FULFILLED':
      return true;
    case 'FETCH_ALL_QUESTION_TYPES_REJECTED':
    case 'FETCH_ALL_QUESTION_TYPES_PENDING':
      return false;
    default:
      return state;
  }
};

const errorMessage = (state = null, action) => {
  switch (action.type) {
    case 'FETCH_ALL_DEPARTMENTS_PENDING':
    case 'FETCH_ALL_DEPARTMENTS_FULFILLED':
    case 'FETCH_ALL_CATEGORIES_PENDING':
    case 'FETCH_ALL_CATEGORIES_FULFILLED':
    case 'FETCH_ALL_QUESTION_TYPES_PENDING':
    case 'FETCH_ALL_QUESTION_TYPES_FULFILLED':
    case 'FETCH_ALL_ROLES_FULFILLED':
    case 'FETCH_ALL_ROLES_PENDING':
      return null;
    case 'FETCH_ALL_DEPARTMENTS_REJECTED':
    case 'FETCH_ALL_CATEGORIES_REJECTED':
    case 'FETCH_ALL_QUESTION_TYPES_REJECTED':
    case 'FETCH_ALL_ROLES_REJECTED':
      return action.payload.message;
    default:
      return state;
  }
};

const utils = combineReducers({
  departments,
  departmentsTotal,
  roles,
  categories,
  questionTypes,
  configs,
  status,
  requestStatus,
  vendorStatus,
  questionStatus,
  questionStatusLoaded,
  prescreenFiles,
  questionnaireFiles,
  reviewFiles,
  auditLog,
  isFetchingAuditLog,
  auditLogExports,
  isFetchingAuditLogExports,
  isFetchingCategories,
  isFetchingDepartments,
  isFetchingRoles,
  isFetchingTypes,
  isLoadedTypes,
  isLoadedRequestStatus,
  isLoadedDepartments,
  errorMessage,
});

export default utils;
